<template>
  <v-card-text>
    <v-container>
      <v-row>
        <v-col>
          <v-card color="grey" flat rounded="xl" class="px-12 py-9">
            <v-card-title class="py-6">
              <v-icon size="32" class="mr-4">
                {{ icons.mdiMoped }}
              </v-icon>
              <span class="text-body-1 font-weight-bold">
                Teslimat Bilgileri</span
              >
            </v-card-title>
            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Adres </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title
                  style="
                    white-space: initial;
                    text-overflow: initial;
                    line-height: 1.5;
                  "
                >
                  {{ callCenterStore.data.delivery.address }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ callCenterStore.data.delivery.city }} /
                  {{ callCenterStore.data.delivery.state }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title>Teslimat Tarihi </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{
                    callCenterStore.deliveryDate | moment("DD MMMM YYYY, dddd")
                  }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  Saat {{ callCenterStore.deliveryHour }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Ödeme </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  <v-chip color="chip" label>
                    {{ callCenterStore.paymentType }}
                  </v-chip>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Şube </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title
                  ><v-chip color="primary" outlined label>
                    {{ callCenterStore.deliveryCustomer }}
                  </v-chip>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Fatura/Fiş Gönderim </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title
                  ><v-chip
                    :color="
                      !callCenterStore.data.delivery.needinvoice
                        ? 'success'
                        : 'error'
                    "
                    label
                    small
                  >
                    {{
                      !callCenterStore.data.delivery.needinvoice
                        ? "Evet"
                        : "Hayır"
                    }}
                  </v-chip>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Fatura Adresi Farklı </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title
                  ><v-chip
                    :color="
                      callCenterStore.data.delivery.isdifferentinvoiceaddr
                        ? 'success'
                        : 'error'
                    "
                    small
                    label
                  >
                    {{
                      callCenterStore.data.delivery.isdifferentinvoiceaddr
                        ? "Evet"
                        : "Hayır"
                    }}
                  </v-chip>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Sipariş Notu </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title
                  style="
                    white-space: initial;
                    text-overflow: initial;
                    line-height: 1.5;
                  "
                >
                  {{ callCenterStore.deliveryNote }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card-text>
</template>

<script>
// Store
import { useCallCenterStore } from "@/stores/callCenter";
import { mdiMoped } from "@mdi/js";
export default {
  setup() {
    const callCenterStore = useCallCenterStore();
    return {
      callCenterStore,
      icons: { mdiMoped },
    };
  },
};
</script>

<style></style>
